export default {
  // Individual Stakeholders
  
};
